// Import model
import { DataviewContactAppointmentResponse } from '../models/DataviewContactAppointmentResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ContactAppointment } from '../models/ContactAppointment';
import { DataView } from '../models/DataView';
import { FilterContactAppointmentRequest } from '../models/FilterContactAppointmentRequest';

// Import dependency serializers (for complex types)
import { ContactAppointmentSerializer } from './ContactAppointmentSerializer';
import { DataViewSerializer } from './DataViewSerializer';
import { FilterContactAppointmentRequestSerializer } from './FilterContactAppointmentRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewContactAppointmentResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewContactAppointmentResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewContactAppointmentResponse instance
   */
  static deserialize(json: string): DataviewContactAppointmentResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewContactAppointmentResponse instance
   */
  static fromObject(obj: any): DataviewContactAppointmentResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewContactAppointmentResponse');
    }


    const instance: DataviewContactAppointmentResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        ContactAppointmentSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterContactAppointmentRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewContactAppointmentResponse instances
   */
  static deserializeArray(json: string): DataviewContactAppointmentResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewContactAppointmentResponse instance to a JSON string
   */
  static serialize(instance: DataviewContactAppointmentResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewContactAppointmentResponse instance to a plain object
   */
  static toObject(instance: DataviewContactAppointmentResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        ContactAppointmentSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterContactAppointmentRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewContactAppointmentResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewContactAppointmentResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
